import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { IDishPositionItemV2 } from 'types';
import Text from 'components/Text/Text';
import { ImgUploaderByPreSignedUrl } from 'components/ImgUploader/ImgUploaderByPreSignedUrl';
import { Badge } from 'components/Badge';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: IDishPositionItemV2;
	positionNumber: number;
	dragHandleProps: DraggableProvidedDragHandleProps | undefined;
}

export const Item: React.FC<IProps> = ({ data, positionNumber, dragHandleProps }) => {
	const containerClasses = classNames(style.container);
	const dishRowClasses = classNames(style.dish, style.row);
	const imgWrapperClass = classNames(style.imgWrapper);
	const dishNameClasses = classNames(style.dishName);
	const articleNumberRowClasses = classNames(style.articleNumber, style.row);
	const stopStatusRowClasses = classNames(style.stopStatus, style.row);
	const priceRowClasses = classNames(style.price, style.row);
	const externalIdRowClasses = classNames(style.externalId, style.row);

	return (
		<div className={containerClasses}>
			<div className={dishRowClasses}>
				<div className={style.positionNumber}>{positionNumber}</div>
				<div className={style.dragMark} {...dragHandleProps}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#dragMark`} />
					</svg>
				</div>
				<div className={imgWrapperClass}>
					<ImgUploaderByPreSignedUrl loaderSize="small" preSignedUrl={data.preSignedUrl} />
				</div>
				<Text className={dishNameClasses} translationKey={data.name} withTooltip={true} />
			</div>
			<Text className={articleNumberRowClasses} translationKey={data.articleNumber} withTooltip={true} />
			<div className={stopStatusRowClasses}>
				<Badge color={data.isDisabled ? 'red' : 'purple'}>
					<Text
						translationNameSpace="listing"
						translationKey={data.isDisabled ? 'inStopLabel' : 'availableMaleLabel'}
						asFragment={true}
						data-test="stopStatus"
					/>
				</Badge>
			</div>
			<Text
				className={priceRowClasses}
				translationKey={`${data.currencySymbol || ''} ${data.price || 0}`}
				withTooltip={true}
			/>
			<Text className={externalIdRowClasses} translationKey={data.externalId} withTooltip={true} />
		</div>
	);
};
